import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentoDinamico, IColumnDinamico, IGetTablaDinamica, ImportDatasetDto, TablasDinamicasConfig, TablasDinamicasDatosDto, UpdateFilaTablaDinamicaDto } from '../../shared/interfaces/database/tramites_automaticos';

@Injectable({
  providedIn: 'root'
})
export class TablasDinamicasConfigService {
  private readonly baseUrl = `${environment.apiUrl}/api/tramites-automaticos`;

  constructor(private readonly http: HttpClient) { }

  //#region Consultar

  getTablasDinamicas(): Observable<TablasDinamicasConfig[]> {
    return this.http.get<TablasDinamicasConfig[]>(`${this.baseUrl}/tablas-dinamicas`);
  }

  getTablaDinamica(id: number): Observable<IGetTablaDinamica> {
    return this.http.get<IGetTablaDinamica>(`${this.baseUrl}/tablas-dinamicas/${id}`);
  }

  consultarDatosTablaDinamica(id: number, ignoreForeignKeys: boolean = false): Observable<TablasDinamicasDatosDto> {
    const params = new HttpParams()
      .set('ignoreForeignKeys', ignoreForeignKeys)
    return this.http.get<TablasDinamicasDatosDto>(`${this.baseUrl}/tablas-dinamicas/datos/${id}`, {params});
  }

  consultarHistoricoFilaTablaDinamica(tablaDinamicaConfigId: number, filaId: number): Observable<TablasDinamicasDatosDto> {
    return this.http.get<TablasDinamicasDatosDto>(`${this.baseUrl}/tablas-dinamicas/historico/${tablaDinamicaConfigId}/${filaId}`);
  }

  getFormularioDataset(tablaDinamicaId: number, columnName: string, columnValue: string): Observable<Record<string, any>[]> {
    const params = new HttpParams()
      .set('columnName', columnName)
      .set('columnValue', columnValue);

    return this.http.get<Record<string, any>[]>(`${this.baseUrl}/tablas-dinamicas/get-formulario-dataset/${tablaDinamicaId}`, { params });
  }

  //#endregion Consultar

  importarDataset(importDatasetDto: ImportDatasetDto): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/importar-tabla`, importDatasetDto);
  }

  editarDataset(tablaDinamicaConfigId: number, importDatasetDto: ImportDatasetDto, newColumns: IColumnDinamico[]): Observable<boolean> {
    const request = {
      importDatasetDto,
      newColumns
    };
    return this.http.put<boolean>(`${this.baseUrl}/editar-tabla/${tablaDinamicaConfigId}`, request);
  }

  desactivar(id:number):Observable<void>{
    return this.http.put<void>(`${this.baseUrl}/desactivar/${id}`, {});
  }

  eliminarFilaTablaDinamica(id: number, filaId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/tablas-dinamicas/${id}/row/${filaId}`);
  }

  //#region editar/insertar filas
  editarFilaDataset(tablaDinamicaConfigId: number, request: UpdateFilaTablaDinamicaDto, documentos?: File[]): Observable<void> {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));

    if (documentos) {
      documentos.forEach(doc => {
        formData.append('documentos', doc);
      });
    }
    return this.http.put<void>(`${this.baseUrl}/tablas-dinamicas/${tablaDinamicaConfigId}/editar-fila`, formData);
  }

  insertarFilaDataset(tablaDinamicaConfigId: number, request: Record<string, any>, documentos?: File[]): Observable<void> {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));

    if (documentos) {
      documentos.forEach(doc => {
        formData.append('documentos', doc);
      });
    }
    return this.http.post<void>(`${this.baseUrl}/tablas-dinamicas/${tablaDinamicaConfigId}/insert-fila`, formData);
  }
  //#endregion editar/insertar filas
  
  descargarDataset(tablaDinamicaConfigId: number, formato: 'xlsx' | 'csv'): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/tablas-dinamicas/descargar/${tablaDinamicaConfigId}?formato=${formato}`,
      { responseType: 'blob' }
    );
  }

  //#region Documentos
  consultarDocumentos(tablaDinamicaConfigId: number, filaId: number): Observable<DocumentoDinamico[]> {
    return this.http.get<DocumentoDinamico[]>(`${this.baseUrl}/tablas-dinamicas/datos/${tablaDinamicaConfigId}/documentos/${filaId}`);
  }

  public descargarDocumento(tablaDinamicaConfigId: number, documentoFilaId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/tablas-dinamicas/datos/${tablaDinamicaConfigId}/documento/descargar/${documentoFilaId}`, { responseType: 'blob' });
  }
  
  borrarDocumento(tablaDinamicaConfigId: number, documentoFilaId: number): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/tablas-dinamicas/datos/${tablaDinamicaConfigId}/documento/${documentoFilaId}`, {});
  }

  public descargarDocumentoFormulario(tablaDinamicaConfigId: number, filaId: number, columnName: string, fileName: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/tablas-dinamicas/datos/documento-formulario/${tablaDinamicaConfigId}/${filaId}/${columnName}/${fileName}`, { responseType: 'blob' });
  }
  //#endregion Documentos

  
}
